import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, Inject, OnInit } from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import * as FileSaver from "file-saver";

@Component({
  selector: "app-preview-pdf",
  templateUrl: "./preview-pdf.component.html",
  styleUrls: ["./preview-pdf.component.scss"],
})
export class PreviewPdfComponent implements OnInit {
  previewTitle: string;
  previewUrl: any;
  zoom_size = 1;

  constructor(
    public dialogRef: MatDialogRef<PreviewPdfComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer,
    private httpClient: HttpClient
  ) {
    if (data) {
      this.previewTitle = data.title;
      this.previewUrl = data.pdfUrl;
    }
  }

  ngOnInit() {}

  close() {
    this.dialogRef.close();
  }

  download(url: string, name: string) {
    FileSaver.saveAs(this.previewUrl, this.previewTitle);
  }

  increaseFontSize() {
    this.zoom_size = this.zoom_size + 0.5;
  }

  decreaseFontSize() {
    this.zoom_size = this.zoom_size - 0.5;
  }
}
